/**
 * Minimum amount of users for clinical statistics to be calculated,
 * when calculating statistics for multiple users.
 * E.g. minimum user count in a medical unit for statistics to be calculated.
 */
export const ClinicalStatisticsMinimumUsersForStatistics = 5;
